import { Component, OnInit, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SettingsConstants } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';
import { HttpClient } from '@angular/common/http';
import { QuillEditorComponent } from 'ngx-quill';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'is-create-note',
  templateUrl: './is-create-note.component.html',
  styleUrls: ['./is-create-note.component.scss']
})
export class IsCreateNoteComponent implements OnInit, AfterViewInit {

  @Output() public createNote = new EventEmitter();
  @Output() public cancelNote = new EventEmitter();

  public user: any = SettingsConstants.LOGGEDUSER;
  public dateFrom: UntypedFormControl = new UntypedFormControl(null);
  public timeFrom: UntypedFormControl = new UntypedFormControl('00:00');
  public dateTo: UntypedFormControl = new UntypedFormControl(null);
  public timeTo: UntypedFormControl = new UntypedFormControl('23:59');

  public authorList: any = [];

  // quill-editor
  @ViewChild(QuillEditorComponent, { static: true }) editor: QuillEditorComponent;
  public quillEditorText: string = null;
  public quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline']
      ]
    },
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      defaultMenuOrientation: 'bottom',
      onSelect: (item, insertItem) => {
        const editor = this.editor.quillEditor;
        insertItem(item);
        editor.insertText(editor.getLength() - 1, '', 'user');
      },
      source: (searchTerm, renderList) => { // mention
        this.authorList = [];
        if (searchTerm !== '') {
          this.getAuthorsListMention(`${SettingsConstants.BACKENDURL}/inspiring/isauth/api/user/?search=${searchTerm}`, renderList, searchTerm);
        } else {
          this.getAuthorsListMention(`${SettingsConstants.BACKENDURL}/inspiring/isauth/api/user/`, renderList, searchTerm);
        }
      }
    }
  };

  constructor(
    private _http: HttpClient,
    private _datePipe: DatePipe,
    private _dateAdapter: DateAdapter<Date>
  ) {
    this._dateAdapter.setLocale('en-GB'); // dd/MM/yyyy
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.user = SettingsConstants.LOGGEDUSER;
  }

  public getAuthorsListMention(url, renderList, searchTerm): void {
    this.authorList = [];
    this._http.get(url).pipe(
      switchMap((data: any) => {
        this.authorList = data.results.map((author: any) => ({
          id: author.id,
          value: author?.str || author?.first_name + ' ' + author?.last_name
        }));

        return of(this.authorList);
      }),
      catchError((error: Error) => {
        console.error(error);
        return of([]); // Return an empty array if there's an error
      })
    ).subscribe((data: any) => {
      renderList(data, searchTerm);
    });
  }

  // prevent matMenu closing
  public preventPanelClosing(event: any): void {
    event.stopPropagation();
  }

  public setSubmitDisabled(): boolean {
    if (this.quillEditorText === null) {
      return true;
    } else {
      return false;
    }
  }

  public cancel(event): void {
    this.quillEditorText = null;
    this.dateFrom.setValue(null);
    this.dateTo.setValue(null);
    this.timeFrom.setValue('00:00');
    this.timeTo.setValue('23:59');
    this.cancelNote.emit();
  }

  public submit(event): void {
    let finalFromDate: string = null;
    if (this.dateFrom.value !== null) {
      let tempTimeFrom = '00:00';
      if (this.timeFrom.value !== '' && this.timeFrom.value !== null && this.timeFrom.value !== undefined) {
        tempTimeFrom = this.timeFrom.value;
      }
      const timeFromTemp = moment(tempTimeFrom, 'hmm').format('HH:mm') !== 'Invalid date' ? moment(tempTimeFrom, 'hmm').format('HH:mm') : tempTimeFrom;
      finalFromDate = this.convertDateTime(this.dateFrom.value, timeFromTemp);
    }
    let finalToDate: string = null;
    if (this.dateTo.value !== null) {
      let tempTimeTo = '23:59';
      if (this.timeTo.value !== '' && this.timeTo.value !== null && this.timeTo.value !== undefined) {
        tempTimeTo = this.timeTo.value;
      }
      const timeToTemp = moment(tempTimeTo, 'hmm').format('HH:mm') !== 'Invalid date' ? moment(tempTimeTo, 'hmm').format('HH:mm') : tempTimeTo;
      finalToDate = this.convertDateTime(this.dateTo.value, timeToTemp);
    }
    const note = {
      text: this.quillEditorText,
      valid_from: finalFromDate,
      valid_to: finalToDate,
      pinned: false
    };

    // reset component
    this.quillEditorText = null;
    this.dateFrom.setValue(null);
    this.dateTo.setValue(null);
    this.timeFrom.setValue('00:00');
    this.timeTo.setValue('23:59');

    this.createNote.emit(note);
  }

  public convertDateTime(dateString: string, timeString: string): string {
    const originalDate = new Date(dateString);
    const day = originalDate.getDate();
    const month = originalDate.getMonth() + 1;
    const year = originalDate.getFullYear();
    const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
    const desiredDateTimeStr = `${formattedDate}T${timeString}:00`;
    return desiredDateTimeStr;
  }
}
